<template>
  <div>
    <my-header></my-header>
  
    <div class="content-container-level-1">
      <div class="h-panel">
        <b-button v-b-modal.help-modal>Help</b-button>

        <b-button
          v-if="mayAddUser"
          :to="{name: 'user_add'}"
          variant="primary"
        >
          New user
        </b-button>
      </div>

      <h2>Users</h2>

      <loading-indicator
        v-if="isLoading"
      />

      <template v-if="groups !== null">
        <users-group
          v-for="group in groups"
          :key="group.role"
          :group="group"
        />
      </template>
    </div>

    <b-modal id="help-modal" title="Справка" ok-only ok-title="Close">
      <div class="help">
        <p>
          На данной странице показаны все пользователи инсайдера.
        </p>
        <p>
          В инсайдере есть 3 группы пользователей: администраторы, модераторы и читатели.
        </p>
        <p>
          Администратор имеет полный доступ ко всем функциям инсайдера.
        </p>
        <p>
          У модератора (в отличие от администратора) нет доступа к&nbsp;администрированию,
          массовой выдаче предметов, массовым банам.
          Модератор может
          начислять/удалять предметы,
          банить/разбанивать игроков,
          переносить прогресс между аккаунтами,
          редактировать данные клубов.
        </p>
        <p>
          Читатель может просматривать игровые данные (об&nbsp;игроках, клубах),
          но не может ничего изменять.
        </p>
      </div>
    </b-modal>

  </div>
</template>

<script>
import auth from '../auth';
import { HTTP } from '../http-common';
import notifier from '../notifier';
import MyHeader from './Header.vue';
import LoadingIndicator from './LoadingIndicator.vue';
import UsersGroup from './UsersGroup.vue';

import { ROLE_ADMIN     } from '../util';
import { ROLE_MODERATOR } from '../util';
import { ROLE_READER    } from '../util';

import { mayAddUserByRole } from '../util';

export default {
  name: 'Users',

  components: {
    MyHeader,
    LoadingIndicator,
    UsersGroup,
  },

  data() {
    return {
      viewer: auth.getViewer(),
      isLoading: false,
      groups: null,
    };
  },

  computed: {
    mayAddUser() {
      return mayAddUserByRole(this.viewer.role);
    },
  },

  created() {
    this.isLoading = true;

    const url = '/users';
    HTTP.get(url)
    .then(response => {
      const data = response.data.data;
      if(data === null) {
        notifier.showError('Invalid server response. data === null.', {sender: this});
        return;
      }

      const users = data;
      const groups = createGroups();
      addUsersToGroups(users, groups);

      this.groups = groups;
    })
    .catch(e => {
      notifier.showError(e.response.data);
    })
    .finally(() => {
      this.isLoading = false;
    });
  },
};

function addUsersToGroups(users, groups) {
  for(let i = 0; i < users.length; i++) {
    const user = users[i];
    const group = findGroupByRole(groups, user.role);
    if(group !== null) {
      group.users.push(user);
    }
  }
}

function createGroups() {
  return [
    {
      role: ROLE_ADMIN,
      users: [],
    },
    {
      role: ROLE_MODERATOR,
      users: [],
    },
    {
      role: ROLE_READER,
      users: [],
    },
  ];
}

function findGroupByRole(groups, role) {
  for(let i = 0; i < groups.length; i++) {
    const group = groups[i];
    if(group.role === role) {
      return group;
    }
  }
  return null;
}
</script>

<style scoped>
  h2 {
    margin-bottom: 0.6em;
  }
  .user-group {
    margin-bottom: 1.8em;
  }
</style>
